<script context="module">
    import {showAlert} from "./store"
    import {get, writable} from 'svelte/store'

    const visible = writable()

    let showed = false

    showAlert.subscribe((value) => {
        showed = false

        if (value.status && value.text) {
            visible.set(true)
        }
    })
</script>

<script>
    import Close from 'src/components/#common/#assets/close.svg'
    import { fade } from 'svelte/transition'
    import {onDestroy} from "svelte";

    if (showed) {
        $visible = false
    }

    let showedTimer

    $: if ($visible) {
        if (showedTimer) {
            clearTimeout(showedTimer)
        }

        showedTimer = setTimeout(function (){
            showed = true
        }, 2000)

        window.document.documentElement.scrollTop = 0
    } else {
        if (showedTimer) {
            clearTimeout(showedTimer)
            showedTimer = null
        }
    }

    onDestroy(() => {
        if (showedTimer) {
            clearTimeout(showedTimer)
        }
    })
</script>

{#if $visible}
    <div class="alerts" transition:fade style="
        --Close:url({Close});
    ">
        <div class="alert alert-{$showAlert.status}">
            <button type="button" on:click={() => { $visible = false }} class="btn-close"></button>
            {$showAlert.text}
        </div>
    </div>
{/if}

<style>
    .alerts {
        position: relative;
    }

    :global(.alert) {
        color: white;
        border-radius: 10px;
        padding: 15px 50px;
        font-size: 17px;
        text-align: center;
        line-height: normal;
        border: 0;
    }

    :global(.alert-success) {
        background: #48a24c;
    }

    :global(.alert-message) {
        background: #ff5d1c;
    }

    :global(.alert-error) {
        background: #ce4036;
    }

    .btn-close {
        position: absolute;
        background: var(--Close) no-repeat;
        top: 16px;
        right: 15px;
        font-size: 14px;
        opacity: 0.7;
        box-shadow: none !important;
        width: 18px;
        height: 18px;
        padding: 0;
        transition: .25s;
    }

    .btn-close:hover {
        opacity: 0.9;
    }

    @media(max-width: 767px) {
        :global(.alert) {
            padding: 12px 40px 12px 12px;
            font-size: 15px;
            text-align: left;
        }

        .btn-close {
            top: 13px;
            right: 12px;
        }

        .form-group label {
            font-size: 12px;
        }
    }
</style>
